:host {
  max-width: 950px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: flex-start;
  margin-left: auto;
  margin-right: auto;
  .cancel {
    display: flex;
    flex-shrink: 1;
    gap: 152px;
    align-items: center;
    align-self: center;
    @media (max-width: 768px) {
      margin: 0;
      flex-direction: column-reverse;
      gap: 24px;
      padding: 24px;
      background: var(--greys-white-ffffff, #fff);
      align-self: stretch;
    }
    .left {
      max-width: 552px;
      display: flex;
      flex-direction: column;
      gap: 32px;

      h1 {
        color: var(--font-primary--invert, #fff);
        font-weight: 400;
        font-size: 24px;
        margin: 0;
        padding: 0;
        @media (max-width: 768px) {
          flex-direction: column;
          color: var(--font-primary, #333);
        }
      }

      p {
        color: var(--bg-secondary, #f5f5f5);
        font-size: 14px;
        margin: 0;
        padding: 0;
        @media (max-width: 768px) {
          color: var(--font-secondary, #666);
          margin-top: -24px;
        }
      }

      button {
        border-radius: 4px;
        background: var(--primary-blue, #0098ff);
        padding: 12px 16px;
        align-self: flex-start;
        color: var(--font-primary--invert, #fff);
        @media (max-width: 768px) {
          align-self: stretch;
        }
      }
    }

    img {
      width: 232px;
      height: 184.874px;
    }
  }

  .title {
    display: flex;
    width: 182px;
    height: 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    text-wrap: nowrap;

    div {
      color: var(--font-primary, #333);
      font-size: 16px;
      font-weight: 600;
    }
    .white {
      color: var(--font-primary--invert, #fff);
    }
  }
}
